import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsString } from '@pit/core';
import { IDtoAddress } from '../interfaces/dto.address.interface';

// @dynamic
@JsonObject('DtoAddress')
export class DtoAddress extends ModelEntity implements IDtoAddress {

    constructor(initValues: Partial<IDtoAddress> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('city', String, true)
    public city?: string = null;

    @JsonProperty('houseNumber', String, true)
    public houseNumber?: string = null;

    @JsonProperty('latitude', Number, true)
    public latitude?: number = null;

    @JsonProperty('longitude', Number, true)
    public longitude?: number = null;

    @JsonProperty('street', String, true)
    public street?: string = null;

    @JsonProperty('zipCode', String, true)
    public zipCode?: string = null;

    public get fullAddress(): string {
        return UtilsString.stringFormat('{0}, {1}', this.fullStreet, this.fullCity).trim();
    }

    public get fullCity(): string {
        return UtilsString.stringFormat('{0} {1}', this.zipCode, this.city).trim();
    }

    public get fullStreet(): string {
        return UtilsString.stringFormat('{0} {1}', this.street, this.houseNumber).trim();
    }

}
